/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_AdjustmentInputs */

const en_new_adjustment = /** @type {(inputs: New_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Adjustment`)
};

const es_new_adjustment = /** @type {(inputs: New_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo ajuste`)
};

/**
* | output |
* | --- |
* | "New Adjustment" |
*
* @param {New_AdjustmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const new_adjustment = /** @type {((inputs?: New_AdjustmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_AdjustmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_adjustment(inputs)
	return es_new_adjustment(inputs)
});